import { combineReducers } from "@reduxjs/toolkit";
import { ootrMainReducer } from "../../ootr/OotrReducer";
import { ootrSphereReducer } from "../../ootr/sphere/OotrSphereReducer";
import { appContextReducer } from "./AppContextReducer";
import { tournoiFrancoReducer } from "../../ootr/tournoifr/tracker/TournoiFrancoReducer";


export const ootrReducer = combineReducers({
  main: ootrMainReducer,
  tournoiFranco: tournoiFrancoReducer,
  sphere: ootrSphereReducer
});
// ui reducer
export const uiReducer = combineReducers({
  ootr: ootrReducer
});

// app reduceer
export const appReducer = combineReducers({

  // ui
  ui: uiReducer,

  // app
  appContext: appContextReducer

});

export type AppState = ReturnType<typeof appReducer>;

